var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"w-100 text-center",style:(_vm.boxStyle)},[(_vm.ready)?_c('img',{class:_vm.imgClass,style:(_vm.finalSize),attrs:{"src":_vm.finalScr,"alt":_vm.alt}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }